import React from "react";
import "./Header.css";
import myPhoto from "../../assets/possibility.png";
export const Header = () => {
  return (
    <div className="gpt3__header section__padding" id="home">
      <div className="gpt3__header-content">
        <h1>Hi.. Am Eliya Gervas</h1>
        <h3>Full Stack Developer</h3>
        <p>
          Dedicated to design and implement state of the art solutions using
          modern technics and tools I have learnt throw the course of time,
          let's work together on your next project
        </p>
        <a href="#contacts">
          <button type="button">Contact Me </button>
        </a>
      </div>
      <div className="gpt3__header-image">
        <img src={myPhoto} alt="ai" />
      </div>
    </div>
  );
};
